// frontend/src/components/ActionPlans/Areas.jsx

import React from 'react';
import { ap_areasAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const APAreas = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t('areas.name', 'Name'),
      field: 'area_name'
    },
    {
      header: t('active', 'Active'),
      field: 'is_active',
      render: (row) => row.is_active ? '✓' : '—'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString()
    }
  ];

  const formFields = [
    {
      name: 'area_name',
      label: 'areas.name',
      type: 'text',
      required: true,
      maxLength: 100
    },
    {
      name: 'is_active',
      label: 'active',
      type: 'checkbox',
      defaultValue: true,
      checkboxLabel: 'active'
    }
  ];

  return (
    <MasterDataManager
      title="areas.title"
      subtitle="areas.subtitle"
      createButtonLabel="areas.create"
      api={ap_areasAPI}
      columns={columns}
      formFields={formFields}
      idField="area_id"
      displayField="area_name"
    />
  );
};

export default APAreas;